import React, { useState, useEffect } from 'react';
import PasswordInput from 'Components/Forms/PasswordInput';
import { t } from 'i18n';

const i18nOpts = { scope: 'registration.user' };

const PasswordField = ({
  id = 'user_password',
  name = 'user[password]',
  passwordError,
  containerClassName,
}) => {
  const [password, setPassword] = useState('');
  const [isPasswordLengthMet, setIsPasswordLengthMet] = useState(false);
  const [formErrors, setFormErrors] = useState(passwordError ? passwordError.split(',') : []);

  const checkPasswordLength = (password) => {
    if (typeof password !== "string") return false;
    return [...password].length >= 15;
  }

  const handlePasswordChange = ({ target }) => {
    const val = target.value;
    setPassword(val);

    setIsPasswordLengthMet(checkPasswordLength(val));

    setFormErrors([]);
  };

  return (
    <>
      <PasswordInput
        id={id}
        name={name}
        value={password}
        onChange={handlePasswordChange}
        containerClassName={containerClassName}
        inputContainerClassName={formErrors.length ? 'error-field' : ''}
      />
      {formErrors.length > 1 ? (
        <ul className="error">
          {formErrors.map((error, idx) => (
            <li key={idx}>{error}</li>
          ))}
        </ul>
      ) : (
        <span className="error">{formErrors}</span>
      )}
      {id === 'user_password' && password && (
        <div className="hint">
          {t('must_have', i18nOpts)}
          <ul>
            <li className={isPasswordLengthMet ? 'checkmark' : 'disc'}>{t('fifteen_chars', i18nOpts)}</li>
          </ul>
        </div>
      )}
    </>
  );
};

export default PasswordField;
